@if (label) {
  <div class="badge-container">
    <span class="badge-circle" [style.backgroundColor]="getColor()"></span>
    <span class="badge-text">{{ label }}</span>
  </div>
}